import { useSelector } from "react-redux";
import { useCallback } from "react";

const useTranslation = () => {
  const {
    translations,
    selectedLanguage,
    selectedLanguageCode,
    loadingTranslations,
  } = useSelector((state) => state.language);

  const t = useCallback(
    (key, fallbackOrParams, maybeVars) => {
      if (!key) return "";

      let text = translations[key];
      if (text === undefined) {
        text = translations[`_${key}`];
      }

      // Agency/BD style: t(key, "Fallback string")
      // Host style: t(key, { param: value })
      let fallback = undefined;
      let params = undefined;

      if (typeof fallbackOrParams === "string") {
        fallback = fallbackOrParams;
        params = maybeVars;
      } else if (fallbackOrParams && typeof fallbackOrParams === "object") {
        params = fallbackOrParams;
      }

      if (text === undefined) {
        text = typeof fallback === "string" ? fallback : key;
      }

      if (params && typeof params === "object") {
        Object.entries(params).forEach(([param, value]) => {
          const token = `{${param}}`;
          text = String(text).replaceAll(token, String(value));
        });
      }

      return text;
    },
    [translations],
  );

  return {
    t,
    language: selectedLanguage,
    languageCode: selectedLanguageCode,
    isLoading: loadingTranslations,
  };
};

export default useTranslation;
